import firebase from "firebase/app";

import { useHits } from "react-instantsearch-core";

import algoliaToFirestoreDocument from "astrid-algolia/src/utils/algoliaToFirestoreDocument";

const defaultTransformItems = algoliaToFirestoreDocument(firebase);

export default function useInstantSearchDataTableHits({ transformItems = defaultTransformItems } = {}) {
	return useHits({ transformItems });
}
